import {
    NEXT_BACKEND_URL,
    RESTRICTED_PATHS,
    httpStatus,
} from "@/src/lib/util/config";
import axios from "axios";
import store from "@/src/lib/store";
import { logout } from "../../store/user-details/slice";
import nonceHandler from "../../util/nonceHandler";

export default class BaseApiService {
    constructor() {
        this.axiosInstance = axios.create({
            baseURL: NEXT_BACKEND_URL,
            withCredentials: true,
        });

        this.axiosInstance.interceptors.request.use(
            async (config) => {
                const requestData = config.data ? config.data : {};
                const { nonce, originToken, signature } =
                    nonceHandler.getGeneratedEncryptedCredentials(requestData);

                config.headers["x-nonce"] = nonce;
                config.headers["x-token"] = originToken;
                config.headers["x-signature"] = signature;
                return config;
            },
            (error) => Promise.reject(error)
        );

        this.axiosInstance.interceptors.response.use(
            (response) => {
                if (response.status === httpStatus.UNAUTHENTICATED) {
                    this.handleRestrictedResponse();
                }
                return response;
            },
            (error) => {
                if (error?.response) {
                    const { status, headers } = error?.response || {};

                    if (
                        status === httpStatus.UNAUTHORIZED ||
                        status === httpStatus.UNAUTHENTICATED ||
                        status === httpStatus.FORBIDDEN
                    ) {
                        store.dispatch(logout());
                        this.handleRestrictedResponse();
                        return Promise.resolve({
                            data: {
                                message:
                                    "Logged out due to unauthorized access",
                            },
                            status: httpStatus.UNAUTHORIZED,
                        });
                    }
                }

                return Promise.reject(error);
            }
        );
    }

    handleRestrictedResponse() {
        if (typeof window !== "undefined") {
            const currentPath = window.location.pathname;

            const isRestricted = RESTRICTED_PATHS.some((path) =>
                currentPath.startsWith(path)
            );

            if (isRestricted) {
                store.dispatch(logout());
                window.location.href = "/?login=true";
            }
        } else {
            console.warn("Restricted response handled on the server side.");
        }
    }
}
